'use client'
import React from 'react'
import PropTypes from 'prop-types';
import { Stack, Typography } from '@mui/material';

const BasicCard = ({ title, children }) => ( 
  <Stack spacing={2}>
    <Typography variant="h5">{title}</Typography>
    {children}
  </Stack>
);

BasicCard.propTypes = {
  title: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
};

export default BasicCard;
